import { Map, fromJS } from 'immutable';
import actions from './actions';

const initState = new Map({

  propertyViewingPreferencesLoading: false,
  propertyViewingPreferencesSaving: false,
  propertyViewingPreferencesDeleting: false,
  propertyViewingPreferences: [],
  propertyViewingPreferencesSavedOptions: {},
  propertyViewingPreferencesPropertyDetails: {},
  propertyViewingPreferencesFailedData: {},
  propertyViewingPreferencesSavingFailedData: {},
  propertyViewingPreferencesDeletingFailedData: {},

  propertyViewingPreferencesSingleLoading: false,
  propertyViewingPreferencesSingleSaving: false,
  propertyViewingPreferencesSingleDeleting: false,
  propertyViewingPreferencesSingle: [],
  propertyViewingPreferencesSingleFailedData: {},
  propertyViewingPreferencesSingleSavingFailedData: {},
  propertyViewingPreferencesSingleDeletingFailedData: {},

  loading: false,

  savingLandlordEntityPreferences: false,
  saveLandlordEntitityPreferencesFailedData: {},

  propertyListingPriceData: null,
  propertyListingPaymentData: null,
  propertyListingPaymentProcessing: false,
  propertyListingPaymentSuccessful: false,

  propertyListingRemoving: null,
  propertyListingRemoved: null
});

export default function propertiesReducer(state = initState, action) {
  switch (action.type) {

    // DO_GET_PROPERTY_VIEWING_PREFERENCES
    case actions.DO_GET_PROPERTY_VIEWING_PREFERENCES:
      return state
        .set('propertyViewingPreferencesLoading', true);

    case actions.DO_GET_PROPERTY_VIEWING_PREFERENCES_SUCCESS:
      return state
        .set('propertyViewingPreferencesLoading', false)
        .set('propertyViewingPreferences', action.payload.preferences)
        .set('propertyViewingPreferencesPropertyDetails', action.payload.property)
        .set('propertyViewingPreferencesSavedOptions', action.payload.preferenceOptions)
        .set('propertyViewingPreferencesFailedData', {});

    case actions.DO_GET_PROPERTY_VIEWING_PREFERENCES_FAILED:
      return state
        .set('propertyViewingPreferencesLoading', false)
        .set('propertyViewingPreferences', [])
        .set('propertyViewingPreferencesPropertyDetails', {})
        .set('propertyViewingPreferencesSavedOptions', {})
        .set('propertyViewingPreferencesFailedData', action.payload);

    // DO_GET_PROPERTY_VIEWING_PREFERENCES_SINGLE
    case actions.DO_GET_PROPERTY_VIEWING_PREFERENCES_SINGLE:
      return state
        .set('propertyViewingPreferencesSingleLoading', true);

    case actions.DO_GET_PROPERTY_VIEWING_PREFERENCES_SINGLE_SUCCESS:
      return state
        .set('propertyViewingPreferencesSingleLoading', false)
        .set('propertyViewingPreferencesSingle', action.payload.preferences)
        // we do get this data from action.payload
        // but it is already set with DO_GET_PROPERTY_VIEWING_PREFERENCES_SUCCESS
        // we could maybe set it here as well incase req for DO_GET_PROPERTY_VIEWING_PREFERENCES_SUCCESS failed?
        // .set('propertyViewingPreferencesPropertyDetails', action.payload.property)
        .set('propertyViewingPreferencesSingleFailedData', {});

    case actions.DO_GET_PROPERTY_VIEWING_PREFERENCES_SINGLE_FAILED:
      return state
        .set('propertyViewingPreferencesSingleLoading', false)
        .set('propertyViewingPreferencesSingle', [])
        .set('propertyViewingPreferencesSingleFailedData', action.payload);

    // DO_SAVE_LANDLORD_ENTITY_PREFERENCES
    case actions.DO_SAVE_LANDLORD_ENTITY_PREFERENCES:
      return state
        .set('savingLandlordEntityPreferences', true);

    case actions.DO_SAVE_LANDLORD_ENTITY_PREFERENCES_SUCCESS:
      const ListingEnquiries = action.payload.find(obj => obj.preferenceKey === 'ListingEnquiries').preferenceValue;
      const ListingBookings = action.payload.find(obj => obj.preferenceKey === 'ListingBookings').preferenceValue;
      return state
        .set('savingLandlordEntityPreferences', false)
        .set('propertyViewingPreferencesSavedOptions', {
          ListingEnquiries,
          ListingBookings
        })
        .set('saveLandlordEntitityPreferencesFailedData', {});

    case actions.DO_SAVE_LANDLORD_ENTITY_PREFERENCES_FAILED:
      return state
        .set('savingLandlordEntityPreferences', false)
        .set('saveLandlordEntitityPreferencesFailedData', action.payload)

    case actions.DO_RESET_LANDLORD_ENTITY_PREFERENCES_FAILED:
      return state
        .set('saveLandlordEntitityPreferencesFailedData', {})

    // DO_ADD_PROPERTY_VIEWING_PREFERENCE
    case actions.DO_ADD_PROPERTY_VIEWING_PREFERENCE:
      return state
        .set('propertyViewingPreferencesSaving', true);

    case actions.DO_ADD_PROPERTY_VIEWING_PREFERENCE_SUCCESS:
      const newViewingPreferences = state.get('propertyViewingPreferences');
      newViewingPreferences.push(action.payload.preferenceAdded)
      return state
        .set('propertyViewingPreferencesSaving', false)
        .set('propertyViewingPreferences', newViewingPreferences)
        .set('propertyViewingPreferencesSavingFailedData', {});

    case actions.DO_ADD_PROPERTY_VIEWING_PREFERENCE_FAILED:
      return state
        .set('propertyViewingPreferencesSaving', false)
        .set('propertyViewingPreferencesSavingFailedData', action.payload);

    // DO_ADD_PROPERTY_VIEWING_PREFERENCE_SINGLE
    case actions.DO_ADD_PROPERTY_VIEWING_PREFERENCE_SINGLE:
      return state
        .set('propertyViewingPreferencesSingleSaving', true);

    case actions.DO_ADD_PROPERTY_VIEWING_PREFERENCE_SINGLE_SUCCESS:
      const newViewingSinglePreferences = state.get('propertyViewingPreferencesSingle');
      newViewingSinglePreferences.push(action.payload.preferenceAdded)
      return state
        .set('propertyViewingPreferencesSingleSaving', false)
        .set('propertyViewingPreferencesSingle', newViewingSinglePreferences)
        .set('propertyViewingPreferencesSingleSavingFailedData', {});

    case actions.DO_ADD_PROPERTY_VIEWING_PREFERENCE_SINGLE_FAILED:
      return state
        .set('propertyViewingPreferencesSingleSaving', false)
        .set('propertyViewingPreferencesSingleSavingFailedData', action.payload);

    // DO_RESET_PROPERTY_VIEWING_PREFERENCE_FAILED
    case actions.DO_RESET_PROPERTY_VIEWING_PREFERENCE_FAILED:
      return state
        .set('propertyViewingPreferencesSaving', false)
        .set('propertyViewingPreferencesSingleSaving', false)
        .set('propertyViewingPreferencesSavingFailedData', {})
        .set('propertyViewingPreferencesSingleSavingFailedData', {})

    // DO_DELETE_PROPERTY_VIEWING_PREFERENCE
    case actions.DO_DELETE_PROPERTY_VIEWING_PREFERENCE:
      return state
        .set('propertyViewingPreferencesDeleting', true);

    case actions.DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SUCCESS:
      const newViewingPreferencesAfterDelete = state.get('propertyViewingPreferences');
      const indexToDelete = newViewingPreferencesAfterDelete.findIndex(item => item.id === action.payload.id && item.propertyHash === action.payload.hash);
      newViewingPreferencesAfterDelete.splice(indexToDelete, 1);
      return state
        .set('propertyViewingPreferencesDeleting', false)
        .set('propertyViewingPreferences', newViewingPreferencesAfterDelete)
        .set('propertyViewingPreferencesDeletingFailedData', {});

    case actions.DO_DELETE_PROPERTY_VIEWING_PREFERENCE_FAILED:
      return state
        .set('propertyViewingPreferencesDeleting', false)
        .set('propertyViewingPreferencesDeletingFailedData', action.payload);

    // DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SINGLE
    case actions.DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SINGLE:
      return state
        .set('propertyViewingPreferencesSingleDeleting', true);

    case actions.DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SINGLE_SUCCESS:
      const newViewingSinglePreferencesAfterDelete = state.get('propertyViewingPreferencesSingle');
      const singleIndexToDelete = newViewingSinglePreferencesAfterDelete.findIndex(item => item.id === action.payload.id && item.propertyHash === action.payload.hash);
      newViewingSinglePreferencesAfterDelete.splice(singleIndexToDelete, 1);
      return state
        .set('propertyViewingPreferencesSingleDeleting', false)
        .set('propertyViewingPreferencesSingle', newViewingSinglePreferencesAfterDelete)
        .set('propertyViewingPreferencesSingleDeletingFailedData', {});

    case actions.DO_DELETE_PROPERTY_VIEWING_PREFERENCE_SINGLE_FAILED:
      return state
        .set('propertyViewingPreferencesSingleDeleting', false)
        .set('propertyViewingPreferencesSingleDeletingFailedData', action.payload);

    // DO_RESET_DELETE_PROPERTY_VIEWING_PREFERENCE_FAILED
    case actions.DO_RESET_DELETE_PROPERTY_VIEWING_PREFERENCE_FAILED:
      return state
        .set('propertyViewingPreferencesDeleting', false)
        .set('propertyViewingPreferencesSingleDeleting', false)
        .set('propertyViewingPreferencesDeletingFailedData', {})
        .set('propertyViewingPreferencesSingleDeletingFailedData', {});
    
    // DO_GET_PROPERTY_LISTING_PRICE
    case actions.DO_GET_PROPERTY_LISTING_PRICE:
      return state
        .set('loading', true)
        .set('propertyListingPriceData', null);
    case actions.DO_GET_PROPERTY_LISTING_PRICE_SUCCEEDED:
      return state
        .set('loading', false)
        .set('propertyListingPriceData', fromJS(action.payload));

    // DO_MAKE_STRIPE_ADVERTISE_PAYMENT
    case actions.DO_MAKE_STRIPE_ADVERTISE_PAYMENT:
      return state
        .set('loading', true)
        .set('propertyListingPaymentProcessing', true);
    case actions.DO_MAKE_STRIPE_ADVERTISE_PAYMENT_SUCCEEDED:
      return state
        .set('loading', false)
        .set('propertyListingPaymentProcessing', false)
        .set('propertyListingPaymentSuccessful', true)
        .set('propertyListingPaymentData', fromJS(action.payload));

    case actions.DO_REMOVE_PROPERTY_FROM_PORTAL_QUEUE:
      return state
        .set('propertyListingRemoving', true);
    case actions.DO_PORTAL_QUEUE_REMOVED:
      return state
        .set('propertyListingRemoving', false)
        .set('propertyListingRemoved', false);

    default:
      return state;
  }
}


// propertyListingRemoving: null,
// propertyListingRemoved: null


// WEBPACK FOOTER //
// ./src/redux/propertiesAdvertise/reducer.js